import { TAccountNavigationMenuItem } from '@pb/shared/ui/molecules/account-navigation-menu';
import { getEnvironmentSettings } from '@pb/services';

const { baseUrl, messages } = getEnvironmentSettings();

export const lppNavigationMenuItems: TAccountNavigationMenuItem[] = [
    {
        label: 'Task list',
        href: `${baseUrl}/agent#!tasklist`,
    },
    {
        label: 'Activity',
        href: `${baseUrl}//agent#activityReport`,
    },
    {
        label: 'Search',
        href: `${baseUrl}/search`,
    },
    {
        label: 'Diary',
        children: [
            {
                label: 'View my diary',
                href: `${baseUrl}/agent#!manageDiary`,
            },
            {
                label: 'Set new availability',
                href: `${baseUrl}/agent#!manageDiary/setAvailability`,
            },
            {
                label: 'Create appointment',
                href: `${baseUrl}/agent#!manageDiary/setAvailability?createAval=other`,
            },
            {
                label: 'My availability',
                href: `${baseUrl}/agent#!manageDiary/viewAvailability`,
            },
        ],
    },
    {
        label: 'Messages',
        href: messages,
    },
    {
        label: 'Customers',
        href: `${baseUrl}/agent#!`,
    },
    {
        label: 'Prospects',
        href: `${baseUrl}/agent#!daveProspect`,
    },
    {
        label: 'Links',
        children: [
            {
                label: 'The Blueprint',
                href: `${baseUrl}/agent#!guides/TheBlueprint`,
            },
            {
                label: 'Rightmove',
                href: `http://www.rightmove.com`,
            },
            {
                label: 'Zoopla',
                href: `http://www.zoopla.com`,
            },
            {
                label: 'PrimeLocation',
                href: `http://www.primelocation.com`,
            },
            {
                label: 'S1 Homes',
                href: `http://www.s1homes.com/`,
            },
            {
                label: 'Legals Quote (NI)',
                href: `https://rgsinclair.co.uk/`,
            },
            {
                label: 'Legals Quote (Scotland)',
                href: `https://www.e-zone.co.uk/`,
            },
            {
                label: 'Guidance Manual',
                href: `https://pbonlineassets.azureedge.net/web-images/agents/agentZone/Local_Expert_Guidance_Manual_5th_May_2017.pdf`,
            },
            {
                label: 'Anti Money Laundering',
                href: `${baseUrl}/agent#!guides/antiMoneyLaundering`,
            },
        ],
    },
];
